import { queryOptions } from '@tanstack/react-query';
import API from '@/api';
import { queryKeys } from '@/api/utils/queryKeys';

export const userPaymentProtectionInsuranceQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.userPaymentProtectionInsurance,
    queryFn: API.user.getUserPaymentProtectionInsurance,
    staleTime: Infinity,
  });
